module.exports = __webpack_public_path__ + "img/mobile-pressure.2debe805.png";